import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "@components"
import { useStockChangesReportForm } from "../../@hooks"


export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useStockChangesReportForm()

    return <Box componet="span" data-tour="changes-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}